export const useAsset = (pathname: string) => {
  const config = useRuntimeConfig()

  if (!pathname.startsWith('/')) {
    pathname = `/${pathname}`
  }

  return `${config.public.assetUrl}${pathname}`
}
